<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
    <circle cx="7" cy="7" r="7" fill="url(#paint0_linear)" />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="7.156"
        x2="7.156"
        y1="11.333"
        y2="3.333"
        gradientUnits="userSpaceOnUse"
      >
        <stop :stop-color="stopColor1" />
        <stop offset="1" :stop-color="stopColor2" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'IconDot',
  props: {
    stopColor1: {
      type: String,
      default: '#4659FF',
    },
    stopColor2: {
      type: String,
      default: '#8146FF',
    },
  },
};
</script>
